import React from "react";
import { Button } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import Summary, { SummaryField, SummaryText, Actions } from "../Summary";

/** "Insights" — three reflective prompts. The question carries the framing. */
const FIELDS = [
  { key: "metaphors", label: "An insight from the metaphor exercise" },
  { key: "heroes", label: "An insight from the heroes exercise" },
  { key: "life_constraint", label: "A constraint that came up" },
];

const Insight: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const complete = FIELDS.every((f) => (payload[f.key] || "").trim().length > 1);

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        {FIELDS.map((field) => (
          <SummaryField key={field.key} label={field.label}>
            <SummaryText>{payload[field.key]}</SummaryText>
          </SummaryField>
        ))}
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      {FIELDS.map((field) => (
        <div className="ix-section" key={field.key}>
          <div className="ix-label">{field.label}</div>
          <div className="field">
            <textarea
              rows={3}
              value={payload[field.key] || ""}
              onChange={(e) => update({ ...payload, [field.key]: e.target.value })}
            />
          </div>
        </div>
      ))}

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default Insight;
